import { useEffect, useState } from 'preact/hooks'
import styles from './ui.module.css'

/**
 * During countdown and race only the Pixi scene and HUD show (PHASE1 T1.8); Preact adds one
 * Leave button that asks first, so a stray tap never drops a race. Escape opens or closes the
 * question. There is no pause: the race goes on behind it. Online Leave goes to the hub through
 * the session; practice (its own page) mounts the same bar and goes to the hub page (D-066).
 */
export function RaceOverlay({ onLeave }: { onLeave: () => void }) {
  const [asking, setAsking] = useState(false)

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.code === 'Escape') setAsking((a) => !a)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const blurThen = (fn: () => void) => (e: Event) => {
    // Game keys (Space, Enter) must not land on a focused button mid-race.
    ;(e.currentTarget as HTMLElement).blur()
    fn()
  }

  return (
    <div class={styles.raceBar}>
      {asking ? (
        <div class={styles.confirm} role="dialog" aria-label="Leave the race?">
          Leave the race?
          <button
            type="button"
            class={`${styles.button} ${styles.small} ${styles.danger}`}
            onClick={blurThen(onLeave)}
          >
            Leave
          </button>
          <button
            type="button"
            class={`${styles.button} ${styles.small}`}
            onClick={blurThen(() => setAsking(false))}
          >
            Stay
          </button>
        </div>
      ) : (
        <button
          type="button"
          class={`${styles.button} ${styles.small}`}
          onClick={blurThen(() => setAsking(true))}
        >
          Leave
        </button>
      )}
    </div>
  )
}
